import React from "react";
import { Card, Button, Accordion } from "react-bootstrap";
import StudentTable from "./StudentTable";

const StudentsSection = ({ students }) => {
  return (
    <Accordion defaultActiveKey="0" className="my-4">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Students</Accordion.Header>
        <Accordion.Body>
          <StudentTable students={students} />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default StudentsSection;
